import {useContext} from "react";
import AuthContext from "../context/useAuthContext";

const useAuthHook = () =>{
    return useContext(AuthContext);
}
export default useAuthHook;